import 'prop-types';
import React, { useState, useMemo, useEffect } from 'react';
import _isEqual from 'lodash/isEqual';
import { getInterestRate, calculatePersonalPayment } from '@atc/wallet-payment-fns';
import { defaultPaymentInfo } from 'axl-config';
import Payment from '../Payment/Payment.js';
import { jsx } from 'react/jsx-runtime';
function PersonalPayment(_ref) {
  let {
    textColor,
    price,
    paymentsInfo,
    uiContext,
    vehicleCondition,
    personalizedPayment,
    shouldUpdatePayment = true,
    handleFallbackPayment = () => {}
  } = _ref;
  const [payment, setPayment] = useState(personalizedPayment || null);
  const interestRates = paymentsInfo?.interestRate || defaultPaymentInfo.interestRate;
  const interestRate = useMemo(() => getInterestRate(interestRates, vehicleCondition), [interestRates, vehicleCondition]);
  useEffect(() => {
    const handleUpdateMonthlyPayment = () => {
      const monthlyPayment = Math.max(0, calculatePersonalPayment(price, paymentsInfo || defaultPaymentInfo, interestRate)) || 0;
      setPayment(monthlyPayment);
      handleFallbackPayment({
        payment: monthlyPayment,
        rate: interestRate,
        term: paymentsInfo.loanTerm || defaultPaymentInfo.loanTerm
      });
    };
    if (shouldUpdatePayment || payment === null) {
      if (personalizedPayment && typeof interestRates.custom !== 'number') {
        if (personalizedPayment !== payment) setPayment(personalizedPayment);
      } else {
        handleUpdateMonthlyPayment();
      }
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [paymentsInfo, personalizedPayment, shouldUpdatePayment, handleFallbackPayment]);
  return /*#__PURE__*/jsx(Payment, {
    payment: payment,
    textColor: textColor,
    uiContext: uiContext
  });
}
/**
 * Returns a computed payment based on inputs or provided payment object, displayed with "$/mo".
 * If you do not need the calculation, use the `<Payment />` component directly for just formatting.
 *
 * @component
 */
var PersonalPayment$1 = /*#__PURE__*/React.memo(PersonalPayment, (prevProps, nextProps) => _isEqual(prevProps.paymentsInfo, nextProps.paymentsInfo) && _isEqual(prevProps.personalizedPayment, nextProps.personalizedPayment) && prevProps.shouldUpdatePayment === nextProps.shouldUpdatePayment && prevProps.uiContext === nextProps.uiContext);
export { PersonalPayment$1 as default };
